<template>
  <div class="examineBox myStatementApply">
    <self-back :pageHeaderList="[{ 'name': '结算单审核' }]"></self-back>
    <div class="containter" v-loading='loading'>
      <ul class="topTab clear">
        <li :class="tab == 5 ? 'active' : ''" @click="tab = 5; status = ''">游戏/电商结算单</li>
        <li :class="tab == 6 ? 'active' : ''" @click="tab = 6; status = ''">拼多多结算单</li>
        <li :class="tab == 4 ? 'active' : ''" @click="tab = 4; status = ''">CPA结算单</li>
        <li :class="tab == 2 ? 'active' : ''" @click="tab = 2; status = ''">MCN结算单</li>
        <el-input placeholder="请输入申请人" v-model.trim="keyword" clearable
          @keydown.enter.native="keyword ? getStatementsIndex(1) : ''" @clear="getStatementsIndex(1)" size="mini"
          style="width:200px;float:right;margin-top:12px;margin-right:20px;">
          <el-button slot="append" icon="el-icon-search" @click="keyword ? getStatementsIndex(1) : ''"
            style="padding:0 10px"></el-button>
        </el-input>
        <div style="float:right;margin-top:12px;margin-right:10px">
          <label style="font-size:13px">财务审核时间：</label>
          <el-date-picker @change="getStatementsIndex(1)" style="width:240px" v-model="approved_date" type="daterange"
            value-format="yyyy-MM-dd" size='mini' range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </div>
      </ul>
      <div style="margin: 0 16px 5px;" class="topSelect flex">
        <div class="selectItem">
          <label>审核状态：</label>
          <el-select v-model="status" @change="getStatementsIndex(1)" style="width:150px" size="mini" clearable
            placeholder="审核状态">
            <el-option v-for="(item, index) in userInfo.role_id == 10 ? statusListCW : statusList" :key="index"
              :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="selectItem">
          <label>签约公司</label>
          <el-select v-model="company" @change="getStatementsIndex(1)" style="width:150px" size="mini" clearable
            placeholder="签约公司">
            <el-option v-for="(item, index) in customerList" :key="index" :label="item.company" :value="item.company">
            </el-option>
          </el-select>
        </div>
        <div class="selectItem">
          <label>消耗表月份：</label>
          <el-date-picker @change="getStatementsIndex(1)" style="width:140px;" v-model="screenMonth" :clearable='true'
            type="month" size="mini" value-format="yyyy-MM" placeholder="月份筛选">
          </el-date-picker>
        </div>
        <div class="selectItem">
          <label>申请日期：</label>
          <el-date-picker @change="getStatementsIndex(1)" v-model="timeMonth" style="width:240px" type="daterange"
            size="mini" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div class="selectItem">
          <label>甲方名称：</label>
          <el-input placeholder="请输入甲方名称" v-model.trim="customer_name" clearable
            @keydown.enter.native="customer_name ? getStatementsIndex(1) : ''" @clear="getStatementsIndex(1)" size="mini"
            style="width:200px">
            <el-button slot="append" icon="el-icon-search" @click="customer_name ? getStatementsIndex(1) : ''"
              style="padding:0 10px"></el-button>
          </el-input>
        </div>
        <div class="selectItem">
          <label>序列号：</label>
          <el-input placeholder="请输入序列号" v-model.trim="serial_number" clearable
            @keydown.enter.native="serial_number ? getStatementsIndex(1) : ''" @clear="getStatementsIndex(1)" size="mini"
            style="width:200px">
            <el-button slot="append" icon="el-icon-search" @click="serial_number ? getStatementsIndex(1) : ''"
              style="padding:0 10px"></el-button>
          </el-input>
        </div>
        <template v-if="userInfo.role_id == 10 || userInfo.role_id == 18">
          <el-select v-model="pre_audit_status" @change="getStatementsIndex(1)" style="width:150px;margin-right:15px;" size="mini"
            clearable placeholder="结算单预审状态">
            <el-option v-for="(item, index) in pre_audit_list" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </template>
      </div>
      <div class="listBox">
        <el-table class="table" :header-cell-style="{ background: '#f5f7fa' }" :data="accountList"
          height="calc(100vh - 288px)" border>
          <el-table-column prop="id" label="序列号" align='center' width="80" fixed="left"></el-table-column>
          <el-table-column prop="amount" label="订单金额" align='center' width="90"></el-table-column>
          <el-table-column prop="customer_name" label="甲方名称" align='center' width="200"></el-table-column>
          <el-table-column prop="company" label="签约公司" align='center' width="200"></el-table-column>
          <el-table-column prop="applicant" align='center' label="申请人"></el-table-column>
          <el-table-column prop="apply_time" align='center' label="申请时间" min-width="96px"></el-table-column>
          <el-table-column align='center' label="是否作废">
            <template slot-scope="scope">
              <img v-if="scope.row.is_voided == 1" src="@/assets/img/voided.png"
                style="width:40px;height:29px;margin:auto" alt="">
            </template>
          </el-table-column>
          <el-table-column prop="voided_statements_id" min-width="96px" align='center' label="作废序列号"></el-table-column>
          <el-table-column prop="verify_time" width="96px" align='center' label="商务审核时间"></el-table-column>
          <el-table-column prop="confirm_verify_time" width="96px" align='center' label="财务审核时间"></el-table-column>
          <el-table-column min-width="96px" align="center" label="预审结果" fixed="right" v-if="userInfo.role_id == 18 || userInfo.role_id == 10">
            <template slot-scope="scope">
              <span v-if="scope.row.pre_audit_status == 1" style="color:#00BB5D">通过</span>
              <span v-if="scope.row.pre_audit_status == 2" style="color:#d51313">驳回
                <el-popover placement="left-end" title="预审意见" width="400" trigger="hover" :content="scope.row.pre_audit_content">
                  <i class="el-icon-view" slot="reference" style="color: #202652;"></i>
                </el-popover>
              </span>
            </template>
          </el-table-column>
          <el-table-column align='center' label="状态" width="96px" fixed="right">
            <template slot-scope="scope">
              <span v-if="scope.row.verify_status == 0">已保存</span>
              <span v-if="scope.row.verify_status == 1" style="color:#EF7400">商务待审核</span>
              <span v-if="scope.row.verify_status == 2" style="color:#8a8223">财务待审核</span>
              <span v-if="scope.row.verify_status == 3" style="color:#d51313">商务审核驳回</span>
              <span v-if="scope.row.verify_status == 4" style="color:#00BB5D">财务审核通过</span>
              <span v-if="scope.row.verify_status == 5" style="color:#d51313">财务审核驳回</span>
            </template>
          </el-table-column>
          <el-table-column align='center' label="操作" width="96px" fixed="right">
            <template slot-scope="scope">
              <button class="detailButton" @click="goDetail(scope.row)">申请详情</button>
              <button class="detailButton" style="background:#fc726d" @click="deleteStatements(scope.row)"
                v-if="userInfo.role_id == 10 || userInfo.role_id == 21">作废</button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginationBox">
          <el-pagination small background :current-page="page" :page-size="page_size"
            @current-change="handleCurrentChange" layout="total, prev, pager, next, jumper" :total="total" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      detailFlag: false,
      page: 1,
      page_size: 20,
      total: 0,
      loading: false,
      tab: 5,
      accountList: [],
      status: '',
      statusList: [
        { value: 1, label: '待商务审核' },
        { value: 2, label: '待财务审核' },
        { value: 3, label: '商务审核驳回' },
        { value: 4, label: '财务审核通过' },
        { value: 5, label: '财务审核驳回' },
      ],
      statusListCW: [
        { value: 2, label: '待财务审核' },
        { value: 4, label: '财务审核通过' },
        { value: 5, label: '财务审核驳回' },
      ],
      timeMonth: '',
      screenMonth: '',
      customer_name: '',
      statement_id: '',
      keyword: '',
      userInfo: {},
      approved_date: [],
      customerList: [],
      company: '',
      serial_number: '',
      pre_audit_status: '',
      pre_audit_list: [
        { label: '待审核', value: 0 },
        { label: '审核通过', value: 1 },
        { label: '审核驳回', value: 2 },
      ]
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    if (this.$route.query.type) {
      this.tab = this.$route.query.type
    }
    this.getCompany()
    this.getStatementsIndex(1)
  },
  mounted () {
  },
  methods: {
    deleteStatements (data) {//作废结算单
      this.$confirm('确定作废此结算单？', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.$axios.get(this.URL.BASEURL + this.URL.deleteStatements, {
          params: {
            id: data.id,
          }
        }).then((res) => {
          var res = res.data;
          this.loading = false;
          if (res && res.errno == 0) {
            this.getStatementsIndex(this.page)
          } else {
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      }).catch((action) => {
      });
    },
    goDetail (data) {
      this.statement_id = data.id;
      let routeData = this.$router.resolve({
        path: '/examineStatement/' + this.tab + '/' + this.statement_id,
      })
      this.$winopen(routeData.href)
    },
    handleCurrentChange (val) {
      this.getStatementsIndex(val)
    },
    getStatementsIndex (page) {
      this.loading = true;
      this.page = page
      this.$axios.get(this.URL.BASEURL + this.URL.statementsIndex, {
        params: {
          id: this.serial_number,
          type: this.tab,
          month: this.screenMonth,
          status: this.status,
          page: page,
          page_size: this.page_size,
          apply_start_date: this.timeMonth && this.timeMonth.length > 0 ? this.timeMonth[0] : '',
          apply_end_date: this.timeMonth && this.timeMonth.length > 0 ? this.timeMonth[1] : '',
          customer_name: this.customer_name,
          applicant: this.keyword,
          approved_start_date: this.approved_date && this.approved_date.length > 0 ? this.approved_date[0] : '',
          approved_end_date: this.approved_date && this.approved_date.length > 0 ? this.approved_date[1] : '',
          company: this.company,
          pre_audit_status: this.pre_audit_status
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.accountList = res.rst.data;
          this.total = res.rst.pageInfo.total;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getCompany () {
      this.$axios.get(this.URL.BASEURL + this.URL.signCompanyList, {
        params: {
          page: 1,
          pagesize: 999,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.customerList = res.rst.data;
        } else {
        }
      }).catch(() => {
      })
    },
  },
  watch: {
    tab () {
      this.getStatementsIndex(1)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../statementApply.scss";

.flex {
  display: flex;
  flex-wrap: wrap;
}

.selectItem {
  margin-bottom: 5px;
  margin-right: 20px;
}

.topTab {
  margin-bottom: 10px;
}
</style>
<style lang="scss">
.myStatementApply {
  .el-range-editor--mini .el-range-separator {
    width: 20px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newBilling/examine/statementExamine.vue